import type { ReactNode } from "react";
import { Provider as ReduxProvider } from "react-redux";

import { Toaster } from "sonner";

import { store } from "@/store";

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ReduxProvider store={store}>
      {children}
      <Toaster position="top-right" richColors closeButton />
    </ReduxProvider>
  );
}
